import "core-js/modules/es.array.map";
import "core-js/modules/es.array.splice";
import _toConsumableArray from "D:/work/admin/drone_race_manage/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import Sortable from "sortablejs";
export default {
  data: function data() {
    return {
      language: [{
        label: '简体中文',
        value: 'cn'
      }, {
        label: '繁体中文',
        value: 'tc'
      }, {
        label: '英文',
        value: 'en'
      }],
      AnnouncemenTypeList: [{
        label: '系统公告',
        value: 'sys'
      }, {
        label: '游戏公告',
        value: 'game'
      }]
    };
  },
  mounted: function mounted() {
    this.tableBody && this.initSort(this.tableBody, this.sortReq);
  },
  methods: {
    initSort: function initSort(type, reqFn) {
      var _this = this;

      var el = document.querySelectorAll(".".concat(type, " .el-table__body-wrapper > table > tbody"))[0];
      this.sortable = new Sortable(el, {
        animation: 150,
        delay: 0,
        filter: '.ignore-sorting',
        preventOnFilter: false,
        onStart: function onStart(evt) {
          // 允许在拖动时选择文本
          evt.originalEvent.preventDefault();
        },
        onEnd: function onEnd(_ref) {
          var newIndex = _ref.newIndex,
              oldIndex = _ref.oldIndex;

          var tableList = _toConsumableArray(_this.tableData);

          var temp;
          temp = tableList[oldIndex];
          tableList.splice(oldIndex, 1);
          tableList.splice(newIndex, 0, temp);
          var newList = tableList.map(function (i) {
            return i.sort;
          });
          newList.sort(function (a, b) {
            return a - b;
          });
          newList.reverse(); // tableList.map((i, index) => {
          //   i.sort = newList[index]
          // })

          console.log("2=====", tableList);
          var ids = tableList.map(function (a) {
            return a.id;
          });
          _this.tableData = [];

          _this.$api[reqFn]({
            'ids': ids,
            isMustAppid: _this.paramsData.isMustAppid,
            appid: _this.paramsData.appid
          });

          _this.$nextTick(function () {
            _this.tableData = tableList;
          });
        }
      });
    }
  }
};